import { render, staticRenderFns } from "./ViewToggle.vue?vue&type=template&id=6b64213e&scoped=true&"
import script from "./ViewToggle.vue?vue&type=script&lang=js&"
export * from "./ViewToggle.vue?vue&type=script&lang=js&"
import style0 from "./ViewToggle.vue?vue&type=style&index=0&id=6b64213e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b64213e",
  null
  
)

export default component.exports